/**
 * Country slug mappings for different locales
 * Maps locale-specific slugs to country identifiers
 */
export const countrySlugMap: Record<string, Record<string, string>> = {
  en: {
    'network-marketing-software-company-in-italy': 'italy',
    'network-marketing-software-company-in-germany': 'germany',
    'network-marketing-software-company-in-denmark': 'denmark',
    'network-marketing-software-company-in-malaysia': 'malaysia',
    'network-marketing-software-company-in-singapore': 'singapore',
    'network-marketing-software-company-in-us': 'us',
    'network-marketing-software-company-in-spain': 'spain',
    'network-marketing-software-company-in-france': 'france',
    'network-marketing-software-company-in-united-kingdom': 'unitedKingdom',
  },
  es: {
    'compania-de-software-de-marketing-en-red-que-implementa-un-sistema-mlm-rentable-en-italia': 'italy',
    'compania-de-software-de-marketing-en-red-que-implementa-un-sistema-mlm-rentable-en-alemania': 'germany',
    'compania-de-software-de-marketing-en-red-que-implementa-un-sistema-mlm-rentable-en-dinamarca': 'denmark',
    'compania-de-software-de-marketing-en-red-en-malasia': 'malaysia',
    'network-marketing-software-company-in-singapore': 'singapore',
    'network-marketing-software-company-in-us': 'us',
    'reseau-de-logiciels-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-en-espagne': 'spain',
    'compania-de-software-de-marketing-en-red-que-implementa-un-sistema-mlm-rentable-en-francia': 'france',
    'compania-de-software-de-marketing-en-red-que-implementa-un-sistema-mlm-rentable-en-reino-unido': 'unitedKingdom',
  },
  fr: {
    'societe-de-logiciels-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-en-italie': 'italy',
    'societe-de-logiciels-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-en-allemagne': 'germany',
    'societe-de-logiciels-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-au-danemark': 'denmark',
    'market-market-lofware-compose-en-malaisie': 'malaysia',
    'market-marketing-lowware-compose-dans-le-singapore': 'singapore',
    'market-marketing-lowware-compose-dans-les-etats-unis': 'us',
    'societe-de-logiciels-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-en-espagne': 'spain',
    'societe-de-logiciel-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-en-france': 'france',
    'entreprise-de-logiciel-de-marketing-de-reseau-mettant-en-œuvre-un-systeme-mlm-rentable-au-royaume-uni': 'unitedKingdom',
  },
  it: {
    'empresa-de-software-de-marketing-de-red-implementando-un-sistema-de-mlm-economico-en-italia': 'italy',
    'societa-di-software-di-network-marketing-che-implementa-il-sistema-mlm-economico-in-germania': 'germany',
    'azienda-di-software-di-marketing-di-rete-che-implementa-un-sistema-mlm-redditizio-in-danimarca': 'denmark',
    'societa-di-software-di-network-marketing-che-implementa-il-sistema-mlm-economico-in-danimarca': 'denmark',
    'network-marketing-software-company-in-malaysia': 'malaysia',
    'network-marketing-software-company-in-singapore': 'singapore',
    'network-marketing-software-company-in-us': 'us',
    'societa-di-software-di-network-marketing-che-implementa-il-sistema-mlm-economico-in-spagna': 'spain',
    'azienda-di-software-di-network-marketing-in-francia': 'france',
    'societa-di-software-di-marketing-di-rete-che-implementa-il-sistema-mlm-economico-in-francia': 'france',
    'azienda-di-software-di-marketing-di-rete-che-implementa-un-sistema-mlm-redditizio-nel-regno-unito': 'unitedKingdom',
  },
  de: {
    'network-marketing-softwareunternehmen-implementieren-kostenguenstiges-mlm-system-in-italien': 'italy',
    'netzwerk-marketing-software-unternehmen-das-kosteneffektive-mlm-system-in-deutschland-implementiert': 'germany',
    'netzwerkmarketing-softwareunternehmen-in-deutschland': 'germany',
    'network-marketing-software-unternehmen-in-daenemark': 'denmark',
    'network-marketing-softwareunternehmen-implementieren-ein-kostenguenstiges-mlm-system-in-daenemark': 'denmark',
    'network-marketing-software-company-in-malaysia': 'malaysia',
    'network-marketing-software-company-in-singapore': 'singapore',
    'network-marketing-software-company-in-in-us': 'us',
    'network-marketing-softwareunternehmen-implementieren-kostenguenstiges-mlm-system-in-spanien': 'spain',
    'societa-di-software-di-marketing-di-rete-che-implementa-il-sistema-mlm-economico-in-francia': 'france',
    'network-marketing-software-unternehmen-im-vereinigten-koenigreich': 'unitedKingdom',
  },
  zh: {
    'zai-yi-da-li-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si': 'italy',
    'zai-de-guo-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si': 'germany',
    'zai-dan-mai-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si': 'denmark',
    'zai-ma-lai-xi-ya-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si': 'malaysia',
    'zai-xin-jia-po-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si': 'singapore',
    'zai-mei-guo-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si': 'us',
    'zai-xi-ban-ya-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si': 'spain',
    'zai-fa-guo-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si': 'france',
    'zai-ying-guo-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si': 'unitedKingdom',
  },
};

/**
 * Reverse mapping: country identifier to locale-specific slugs
 */
export const countryToSlugMap: Record<string, Record<string, string>> = {
  italy: {
    en: 'network-marketing-software-company-in-italy',
    es: 'compania-de-software-de-marketing-en-red-que-implementa-un-sistema-mlm-rentable-en-italia',
    fr: 'societe-de-logiciels-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-en-italie',
    it: 'empresa-de-software-de-marketing-de-red-implementando-un-sistema-de-mlm-economico-en-italia',
    de: 'network-marketing-softwareunternehmen-implementieren-kostenguenstiges-mlm-system-in-italien',
    zh: 'zai-yi-da-li-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si',
  },
  germany: {
    en: 'network-marketing-software-company-in-germany',
    es: 'compania-de-software-de-marketing-en-red-que-implementa-un-sistema-mlm-rentable-en-alemania',
    fr: 'societe-de-logiciels-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-en-allemagne',
    it: 'societa-di-software-di-network-marketing-che-implementa-il-sistema-mlm-economico-in-germania',
    de: 'netzwerkmarketing-softwareunternehmen-in-deutschland',
    zh: 'zai-de-guo-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si',
  },
  denmark: {
    en: 'network-marketing-software-company-in-denmark',
    es: 'compania-de-software-de-marketing-en-red-que-implementa-un-sistema-mlm-rentable-en-dinamarca',
    fr: 'societe-de-logiciels-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-au-danemark',
    it: 'azienda-di-software-di-marketing-di-rete-che-implementa-un-sistema-mlm-redditizio-in-danimarca',
    de: 'network-marketing-software-unternehmen-in-daenemark',
    zh: 'zai-dan-mai-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si',
  },
  malaysia: {
    en: 'network-marketing-software-company-in-malaysia',
    es: 'compania-de-software-de-marketing-en-red-en-malasia',
    fr: 'market-market-lofware-compose-en-malaisie',
    it: 'network-marketing-software-company-in-malaysia',
    de: 'network-marketing-software-company-in-malaysia',
    zh: 'zai-ma-lai-xi-ya-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si',
  },
  singapore: {
    en: 'network-marketing-software-company-in-singapore',
    es: 'network-marketing-software-company-in-singapore',
    fr: 'market-marketing-lowware-compose-dans-le-singapore',
    it: 'network-marketing-software-company-in-singapore',
    de: 'network-marketing-software-company-in-singapore',
    zh: 'zai-xin-jia-po-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si',
  },
  us: {
    en: 'network-marketing-software-company-in-us',
    es: 'network-marketing-software-company-in-us',
    fr: 'market-marketing-lowware-compose-dans-les-etats-unis',
    it: 'network-marketing-software-company-in-us',
    de: 'network-marketing-software-company-in-in-us',
    zh: 'zai-mei-guo-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si',
  },
  spain: {
    en: 'network-marketing-software-company-in-spain',
    es: 'reseau-de-logiciels-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-en-espagne',
    fr: 'societe-de-logiciels-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-en-espagne',
    it: 'societa-di-software-di-network-marketing-che-implementa-il-sistema-mlm-economico-in-spagna',
    de: 'network-marketing-softwareunternehmen-implementieren-kostenguenstiges-mlm-system-in-spanien',
    zh: 'zai-xi-ban-ya-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si',
  },
  france: {
    en: 'network-marketing-software-company-in-france',
    es: 'compania-de-software-de-marketing-en-red-que-implementa-un-sistema-mlm-rentable-en-francia',
    fr: 'societe-de-logiciel-de-marketing-de-reseau-mettant-en-oeuvre-un-systeme-mlm-rentable-en-france',
    it: 'societa-di-software-di-marketing-di-rete-che-implementa-il-sistema-mlm-economico-in-francia',
    de: 'societa-di-software-di-marketing-di-rete-che-implementa-il-sistema-mlm-economico-in-francia',
    zh: 'zai-fa-guo-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si',
  },
  unitedKingdom: {
    en: 'network-marketing-software-company-in-united-kingdom',
    es: 'compania-de-software-de-marketing-en-red-que-implementa-un-sistema-mlm-rentable-en-reino-unido',
    fr: 'entreprise-de-logiciel-de-marketing-de-reseau-mettant-en-œuvre-un-systeme-mlm-rentable-au-royaume-uni',
    it: 'azienda-di-software-di-marketing-di-rete-che-implementa-un-sistema-mlm-redditizio-nel-regno-unito',
    de: 'network-marketing-software-unternehmen-im-vereinigten-koenigreich',
    zh: 'zai-ying-guo-shi-shi-ying-li-xing-mlm-xi-tong-de-wang-luo-ying-xiao-ruan-jian-gong-si',
  },
};

/**
 * Get country identifier from locale-specific slug
 * Handles URL-encoded slugs by trying both encoded and decoded versions
 */
/** Normalize French slug so ASCII "oeuvre" matches map keys that use Unicode "œuvre" (U+0153). */
function normalizeFrenchSlugForLookup(slug: string): string {
  return slug.replace(/oeuvre/g, "\u0153uvre");
}

export function getCountryFromSlug(slug: string, locale: string): string | null {
  // Try exact match first
  const exactMatch = countrySlugMap[locale]?.[slug];
  if (exactMatch) {
    return exactMatch;
  }

  // For French, try with "oeuvre" → "œuvre" so ASCII URLs match map keys
  if (locale === "fr" && slug.includes("oeuvre")) {
    const normalizedSlug = normalizeFrenchSlugForLookup(slug);
    const normalizedMatch = countrySlugMap[locale]?.[normalizedSlug];
    if (normalizedMatch) {
      return normalizedMatch;
    }
  }

  // Try URL-decoded version
  try {
    const decodedSlug = decodeURIComponent(slug);
    if (decodedSlug !== slug) {
      const decodedMatch = countrySlugMap[locale]?.[decodedSlug];
      if (decodedMatch) {
        return decodedMatch;
      }
    }
  } catch (e) {
    // If decoding fails, continue with original slug
  }

  // Try URL-encoded version of all slugs in the map
  const localeSlugs = countrySlugMap[locale];
  if (localeSlugs) {
    for (const [mapSlug, country] of Object.entries(localeSlugs)) {
      try {
        const encodedSlug = encodeURIComponent(mapSlug);
        if (encodedSlug === slug || decodeURIComponent(encodedSlug) === slug) {
          return country;
        }
      } catch (e) {
        // Continue if encoding/decoding fails
      }
    }
  }

  return null;
}

/**
 * Get locale-specific slug from country identifier
 */
export function getSlugFromCountry(country: string, locale: string): string | null {
  return countryToSlugMap[country]?.[locale] || null;
}

/**
 * Get all country slugs for static generation
 */
export function getAllCountrySlugs(): Array<{ slug: string; locale: string }> {
  const allSlugs: Array<{ slug: string; locale: string }> = [];

  for (const [locale, slugs] of Object.entries(countrySlugMap)) {
    for (const slug of Object.keys(slugs)) {
      allSlugs.push({ slug, locale });
    }
  }

  return allSlugs;
}

